import { SkeletonPlaceholder, Stack, Tile } from '@carbon/react';
import { Tooltip } from '@carbon/react';
import { Information } from '@carbon/react/icons';

import styles from 'theme/components/aside-quick-view.module.scss';

const QuickViewBox = ({ name, value, isLoading, tooltip }) => (
  <Stack gap={3} className={styles['value-wrapper']}>
    <p className={styles['value-title']}>
      {name}
      {tooltip && (
        <Tooltip align="top-left" label={tooltip}>
          <button className={styles.tooltip} type="button">
            <Information />
          </button>
        </Tooltip>
      )}
    </p>
    {isLoading ? <SkeletonPlaceholder className={styles.skeleton} /> : <Tile className={styles.value}>{value}</Tile>}
  </Stack>
);

export default QuickViewBox;
